/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrBalloonEntity } from '../../models/dbr-balloon-entity';

export interface BalloonsControllerFindAllLaunchedByEvent$Params {
  eventid: number;
}

export function balloonsControllerFindAllLaunchedByEvent(http: HttpClient, rootUrl: string, params: BalloonsControllerFindAllLaunchedByEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrBalloonEntity>>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerFindAllLaunchedByEvent.PATH, 'get');
  if (params) {
    rb.path('eventid', params.eventid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DbrBalloonEntity>>;
    })
  );
}

balloonsControllerFindAllLaunchedByEvent.PATH = '/balloons/launched/{eventid}';
